import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FamiliarEditPage } from './familiar-edit.page';

const routes: Routes = [
  {
    path: '',
    component: FamiliarEditPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FamiliarEditPageRoutingModule {}
